// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

  export const environment = {
    production: false,
    cpManagementURL: 'ws://ocppws.verdemobility.com:8120/websocket/',
    webAPIBaseUrlForImage: 'https://api.verdemobility.in/',
    webAPIBaseUrl: 'https://api.verdemobility.in/api',
    webAPILogBaseUrl: 'https://logs.evsecerebro.com:7074/api',
    webCPOAPIBaseUrl: 'https://api.verdemobility.in:9294/api',
    rttyBaseUrl: 'https://logs.evsecerebro.com:5913',
    clientKey: 'f9c0fe7c-335c-4442-8709-1e569848607b',
    ChangedCPManagementURL: 'ws://lionx.nebulae.io:8140/websocket/Charge_Box_ID',
    modalPopUpWidth: 550,
    currencyCode: 'Rs',
    mqttHost:'mqtt.verdemobility.in',
    mqttPort:3001,
    mqttprotocol: 'wss' as 'wss' | 'ws', 
    mqttClientId:'verdemobility/UI',
    qrCodeURL:'https://charger.verdemobility.com',
    infineonQrCodeURL: 'https://infineon-app.verdemobility.com',
    historyData:'pg-history',
   
  };


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
